import axios from "axios";
import { apiUrl } from "config";

export const fetchMintedV2Ids = async (): Promise<number[]> => {
  const res = await axios.get<number[]>("/apes/v2/ids", {
    baseURL: apiUrl,
  });

  return res.data;
};
